import React from "react";
import { Reveal, WfButton, CreditChip } from "@/components/site/primitives";
import { PROGRAMS } from "@/content/worldFarmers";
import { Link } from "react-router-dom";

export const ProgramsV4 = ({ showMentorship = true }) => {
  const { flats, mentorship } = PROGRAMS;
  return (
    <section id="programs" aria-labelledby="programs-v4-heading" className="bg-white py-16 sm:py-20 lg:py-28">
      <div className="wf-container">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--wf-green-text)]">Hands-on &amp; community-centered</span>
          <h2 id="programs-v4-heading" className="mt-3 font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl lg:text-5xl">Our programs</h2>
        </Reveal>

        {/* Row 1: Flats — image left, text right */}
        <Reveal>
          <div className="mt-14 grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14">
            <div className="relative overflow-hidden rounded-sm border border-[var(--wf-border)] shadow-[var(--wf-shadow)]">
              <img src={flats.image} alt={flats.alt} loading="lazy" className="aspect-[4/3] w-full object-cover" />
              <CreditChip src={flats.image} className="pointer-events-none absolute bottom-3 left-3 rounded-full bg-black/40 px-3 py-1 text-[11px] font-medium text-white/90 backdrop-blur-sm" />
            </div>
            <div>
              <span className="w-fit rounded-full bg-[var(--wf-wheat)] px-3 py-1 text-xs font-semibold text-[var(--wf-maroon)]">{flats.badge}</span>
              <h3 className="mt-4 font-serif text-2xl font-semibold text-[var(--wf-ink)] sm:text-3xl">{flats.title}</h3>
              <p className="mt-4 text-base leading-7 text-muted-foreground">{flats.body}</p>
              <div className="mt-6">
                <WfButton as={Link} to="/programs/flats-mentor-farm" variant="secondary" withArrow className="px-6" data-testid="programs-learn-more-button">Explore the Flats Mentor Farm</WfButton>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Row 2: Mentorship — text left, phases right */}
        {showMentorship && (
        <Reveal>
          <div className="mt-16 grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14">
            <div className="order-2 lg:order-1">
              <div className="rounded-sm border border-[var(--wf-border)] bg-[var(--wf-cream)] p-6 sm:p-8">
                <ol className="space-y-4">
                  {mentorship.phases.map((p) => (
                    <li key={p.n} data-testid={`program-phase-${p.n}`} className="flex items-start gap-4">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--wf-farm-green)] font-serif text-base font-semibold text-white">{p.n}</span>
                      <div>
                        <h4 className="font-serif text-lg font-semibold text-[var(--wf-ink)]">{p.title}</h4>
                        <p className="mt-0.5 text-sm leading-6 text-muted-foreground">{p.text}</p>
                      </div>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <span className="w-fit rounded-full bg-[rgba(47,93,58,0.12)] px-3 py-1 text-xs font-semibold text-[var(--wf-green-text)]">{mentorship.badge}</span>
              <h3 className="mt-4 font-serif text-2xl font-semibold text-[var(--wf-ink)] sm:text-3xl">{mentorship.title}</h3>
              <p className="mt-4 max-w-[52ch] text-base leading-7 text-muted-foreground">{mentorship.body}</p>
            </div>
          </div>
        </Reveal>
        )}
      </div>
    </section>
  );
};
